
































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Resolve } from 'vue-di';
import SectionModule from '~/store/section';
import { ISectionMenuItem } from '~/types/componentTypes';

interface IStepItem extends ISectionMenuItem {
    isSuccess?: boolean;
}

@Component({})
export default class HorizontalStepper extends Vue {
    @Resolve
    public sectionStore!: SectionModule;

    get activeMenuItems() {
        return this.sectionStore.activeUniqueMenuItems;
    }

    get showStepper(): boolean {
        if (this.$route.path.includes('/upload-documents')) return false;
        if (this.$route.path.includes('/pharmacy/pharmacy-information-success')) return false;
        if (this.$route.path.includes('/patient/patient-success')) return false;
        return !!(this.activeMenuItems?.menuItems?.length);
    }

    get allSteps(): IStepItem[] {
        if (!this.activeMenuItems?.menuItems) return [];
        const successStep: IStepItem = {
            id: 'success-virtual',
            title: 'Success',
            route: '/success/',
            completed: false,
            isSuccess: true,
        };
        return [...this.activeMenuItems.menuItems, successStep];
    }

    get pathClass(): string {
        const path = this.$route.path;
        if (path.includes('/hcp/')) return 'h-stepper--hcp';
        if (path.includes('/pharmacy/')) return 'h-stepper--pharmacy';
        return 'h-stepper--patient';
    }

    isStepActive(step: IStepItem): boolean {
        if (step.isSuccess) {
            const p = this.$route.path;
            return p.includes('success') && !p.includes('patient-authorization-success') ? true
                : !!p.includes('patient-authorization-success');
        }
        const path = this.$route.path;
        const route = step.route;
        if (path.endsWith('/') && !route.endsWith('/')) return path === route + '/';
        if (!path.endsWith('/') && route.endsWith('/')) return path === route.slice(0, -1);
        return path === route;
    }

    isStepDone(step: IStepItem): boolean {
        if (step.isSuccess) {
            const p = this.$route.path;
            return p.includes('success');
        }
        return step.completed;
    }

    canClickStep(step: IStepItem): boolean {
        if (step.isSuccess) return false;
        return step.completed && !this.isStepActive(step);
    }

    iconForStep(step: IStepItem): string {
        const base = (this.$router as any).options?.base || '/';
        const title = (step.title || '').toLowerCase();
        if (title.includes('eligibilit')) return `${base}eligibility.svg`;
        if (title.includes('patient information') || title.includes('patient info')) return `${base}patient-information.svg`;
        if (title.includes('health insurance') || title.includes('insurance')) return `${base}health-insurance-information.svg`;
        if (title.includes('prescriber')) return `${base}prescriber-information.svg`;
        if (title.includes('consent') || title.includes('authoriz')) return `${base}patient-authorization.svg`;
        if (title.includes('success')) return `${base}success.svg`;
        return `${base}eligibility.svg`;
    }

    onStepClick(step: IStepItem): void {
        if (!this.canClickStep(step)) return;
        this.$router.push(step.route);
    }
}
